import { render, staticRenderFns } from "./sidebarcommunity.vue?vue&type=template&id=03ce1888"
import script from "./sidebarcommunity.vue?vue&type=script&lang=js"
export * from "./sidebarcommunity.vue?vue&type=script&lang=js"
import style0 from "./sidebarcommunity.vue?vue&type=style&index=0&id=03ce1888&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports